import * as Yup from "yup";

import {
  BRAZIL_PHONE_INVALID_MSG,
  BRAZIL_PHONE_REGEX,
  numbersOnly,
  validarCPF,
} from "helpers/utils";
import { formFieldAtleta } from "./fieldAtleta";

function validateOptionalPhone(value: string | undefined): boolean {
  if (!value) return true;
  const digits = numbersOnly(value);
  if (!digits) return true;
  return BRAZIL_PHONE_REGEX.test(digits);
}

function validateRequiredPhone(value: string | undefined): boolean {
  const digits = numbersOnly(value);
  return BRAZIL_PHONE_REGEX.test(digits);
}

const {
  nome,
  apelido,
  cpf,
  rg,
  dataNascimento,
  equipe,
  email,
  celPhone,
  telefone,
  nomeEmergencia,
  celPhoneEmergencia,
  parentesco,
  planoSaude,
  sexo,
  cep,
  endereco,
  numero,
  bairro,
  cidade,
  uf,
  complemento,
} = formFieldAtleta;

const baseValidate = {
  [nome.name]: Yup.string().required(nome.errorMsg),
  [apelido.name]: Yup.string(),
  [cpf.name]: Yup.string()
    .required(cpf.errorMsg)
    .test("cpf-valido", "CPF inválido", (cpf) =>
      cpf ? validarCPF(cpf) : false
    ),
  [rg.name]: Yup.string().required(rg.errorMsg),
  [dataNascimento.name]: Yup.string().required(dataNascimento.errorMsg),
  [equipe.name]: Yup.string().nullable(),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [celPhone.name]: Yup.string()
    .required(celPhone.errorMsg)
    .test("phone-br", BRAZIL_PHONE_INVALID_MSG, validateRequiredPhone),
  [telefone.name]: Yup.string().test(
    "phone-br",
    BRAZIL_PHONE_INVALID_MSG,
    validateOptionalPhone
  ),
  [nomeEmergencia.name]: Yup.string(),
  [celPhoneEmergencia.name]: Yup.string().test(
    "phone-br",
    BRAZIL_PHONE_INVALID_MSG,
    validateOptionalPhone
  ),
  [parentesco.name]: Yup.string(),
  [planoSaude.name]: Yup.string(),
  [sexo.name]: Yup.string().required(sexo.errorMsg),
  [cep.name]: Yup.string().required(cep.errorMsg),
  [endereco.name]: Yup.string().required(endereco.errorMsg),
  [numero.name]: Yup.string().required(numero.errorMsg),
  [bairro.name]: Yup.string().required(bairro.errorMsg),
  [cidade.name]: Yup.string().required(cidade.errorMsg),
  [uf.name]: Yup.string().required(uf.errorMsg),
  [complemento.name]: Yup.string(),
};

const validationsEdit = Yup.object().shape({
  ...baseValidate,
});

export { validationsEdit };
